/* APP consent v2, 2026-09-06. Shopify Customer Privacy owns consent. */
(function () {
  'use strict';
  var banner=document.getElementById('cookie-consent');
  var status=document.getElementById('app-consent-status');
  var buttons=Array.from(banner.querySelectorAll('[data-app-consent]'));
  var privacy=null;
  var hadBuy=!!document.querySelector('.mobile-buy-bar');
  if(hadBuy){document.body.classList.add('mobile-buy-active');banner.classList.add('above-mobile-buy');}
  function show(){banner.style.display='block';document.body.classList.add('cookie-open');}
  function hide(){banner.style.display='none';document.body.classList.remove('cookie-open');}
  function ready(){
    privacy=window.Shopify.customerPrivacy;
    var consent=privacy.currentVisitorConsent();
    // Follow Shopify regions without replacing any saved visitor choice.
    if((consent.analytics==='' || consent.marketing==='') &&
       (typeof privacy.shouldShowBanner!=='function' || privacy.shouldShowBanner()))show();
  }
  function init(attempt){
    if(window.Shopify && window.Shopify.customerPrivacy){ready();return;}
    if(window.Shopify && window.Shopify.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
        if(error){show();status.textContent='Cookie settings could not load. Please refresh to try again.';return;}
        ready();
      });return;
    }
    if(attempt<20){setTimeout(function(){init(attempt+1);},250);}
    else {show();status.textContent='Cookie settings could not load. Please refresh to try again.';}
  }
  buttons.forEach(function(button){button.addEventListener('click',function(){
    if(!privacy){status.textContent='Cookie settings are loading. Please try again shortly.';return;}
    var accept=button.dataset.appConsent==='accept';
    buttons.forEach(function(b){b.disabled=true;});
    status.textContent='Saving your choice…';
    privacy.setTrackingConsent({analytics:accept,marketing:accept,preferences:accept},function(result){
      buttons.forEach(function(b){b.disabled=false;});
      if(result && result.error){status.textContent='Your choice could not be saved. Please try again.';return;}
      status.textContent='';hide();
      // Old local-only banner storage is deliberately not consulted or reused.
      try{localStorage.removeItem('cookie-consent');}catch(e){}
    });
  });});
  var preferences=document.getElementById('app-cookie-preferences');
  if(preferences)preferences.addEventListener('click',function(){show();buttons[0].focus();});
  init(0);
})();
